import { DocumentTypeProps } from "../../components/uiframeworks/files/uploads/panel";

const SubsidiaryDocumentTypes: DocumentTypeProps[] = [
    {key: "logo", text: "Logo"},
    {key: "legal", text: "SK Menkumham"},
    {key: "tfn", text: "NPWP"},
    {key: "others", text: "Dokumen", isDefault: true}
]

export default SubsidiaryDocumentTypes;